/* KP Farbringe v5.2 (03.09.2026) – Auswahl-Ringe in Produktfarben, sprachunabhängig (de/en/nl).
   Nur der Ring an der gewählten Pille, in der ORIGINALFARBE aus der Palette (kein Abdunkeln, keine Punkte,
   Hintergrund wie in v4) – so hat Max es festgelegt. Einziger Unterschied zu v4: Ring 3px statt 2,5px.
   Erkennt Kissen-, Gehäuse- und Abdruckfarben am Optionswert und setzt data-kp + CSS-Variablen.
   Neue Farbe? Palette P und Wortlisten (BRAND/WORDS/PHRASES) ergänzen. */
(function () {
  var P = {
    black:      ['#1e1e1e', '#f0f0f0'],
    blue:       ['#2a3f8f', '#eef0f7'],
    green:      ['#2e7d4f', '#eef5f1'],
    red:        ['#c03434', '#f9efef'],
    purple:     ['#8b2fa8', '#f5eef8'],
    pink:       ['#e0559a', '#fbeef5'],
    hotpink:    ['#e6007e', '#fbe9f3'],
    yellow:     ['#e6c229', '#fcf8e6'],
    grey:       ['#8d8d8d', '#f3f3f3'],
    taupe:      ['#8c8680', '#f3f2f1'],
    white:      ['#d0d0d0', '#ffffff'],
    lightblue:  ['#6fb7e9', '#eef6fc'],
    lightgreen: ['#7cb35c', '#f2f8ec'],
    applegreen: ['#7cb35c', '#f2f8ec'],
    yellowgreen:['#a3b93a', '#f5f8e8'],
    orange:     ['#e8590c', '#fdf0e7'],
    orangebrown:['#b5651d', '#f8efe6'],
    wood:       ['#d7ae7d', '#faf3e9'],
    none:       ['#666666', '#ffffff'],
    ppink:      ['#f0b7d4', '#fdf3f8'],
    plilac:     ['#d5c3ea', '#f7f2fb'],
    pblue:      ['#c4dff0', '#f1f7fb'],
    pgreen:     ['#cfe8dc', '#f0f8f4'],
    pcream:     ['#f6cba6', '#fdf6ee'],
    morningmist:['#a9a5a2', '#f5f4f4'],
    pinecone:   ['#7a5230', '#f3eee9'],
    fallenleaves:['#c05a28', '#f9efe9'],
    twilight:   ['#4a4e78', '#efeff4'],
    rainforest: ['#1f6e50', '#e9f2ee'],
    shadylane:  ['#64798a', '#eff2f4'],
    chianti:    ['#7c2f3f', '#f3e9eb'],
    hawthornrose:['#c4707e', '#f9f0f1'],
    whiteshimmer:['#cfcfcf', '#fafafa'],
    champagne:  ['#dcc28a', '#faf6ec'],
    goldenglitz:['#cfa43b', '#faf4e4'],
    copper:     ['#b0653a', '#f7eee8'],
    rosegold:   ['#c08081', '#f8f0f0'],
    blackshimmer:['#3a3a3a', '#f0f0f0'],
    bark:       ['#5c4633', '#f1edea'],
    laurelleaf: ['#6c8a4d', '#eff3ea'],
    khaki:      ['#97905b', '#f5f4ec'],
    mistymauve: ['#b98ca4', '#f8f2f5'],
    raspberry:  ['#c43e6b', '#f9ebf0']
  };
  /* Markenfarben (Phrasen, Reihenfolge wichtig: "black shimmer" vor "black") */
  var BRAND = [
    [/morning\s*mist/, 'morningmist'], [/pinecone/, 'pinecone'], [/fallen\s*leaves/, 'fallenleaves'],
    [/twilight/, 'twilight'], [/rain\s*forest/, 'rainforest'], [/shady\s*lane/, 'shadylane'],
    [/chianti/, 'chianti'], [/hawthorn\s*rose/, 'hawthornrose'], [/white\s*shimmer/, 'whiteshimmer'],
    [/champagn/, 'champagne'], [/golden\s*glitz/, 'goldenglitz'], [/elestial\s*copp/, 'copper'],
    [/rose\s*gold/, 'rosegold'], [/black\s*shimmer/, 'blackshimmer'], [/laurel\s*leaf/, 'laurelleaf'],
    [/khaki/, 'khaki'], [/misty\s*mauve/, 'mistymauve'], [/raspberry/, 'raspberry'], [/(^|[^a-z])bark($|[^a-z])/, 'bark']
  ];
  /* Einzelfarben als ganze Wörter (de/en/nl) */
  var WORDS = {
    black: ['schwarz', 'black', 'zwart', 'schw'],
    blue: ['blau', 'blue', 'blauw'],
    green: ['grün', 'gruen', 'green', 'groen'],
    red: ['rot', 'red', 'rood', 'karmijnrood'],
    purple: ['violett', 'violet', 'purple', 'paars', 'lila', 'lilac'],
    pink: ['pink', 'rosa', 'roze'],
    yellow: ['gelb', 'yellow', 'geel'],
    grey: ['grau', 'grey', 'gray', 'grijs'],
    white: ['weiß', 'weiss', 'white', 'wit'],
    lightgreen: ['hellgrün', 'lichtgroen'],
    lightblue: ['lichtblau', 'hellblau', 'lichtblauw', 'hemelsblauw'],
    orange: ['orange', 'oranje', 'dieporanje'],
    orangebrown: ['orangebraun', 'oranjebruin'],
    taupe: ['fehgrau', 'grijsbruin'],
    applegreen: ['apfelgrün', 'appelgroen'],
    yellowgreen: ['gelbgrün', 'geelgroen']
  };
  var PHRASES = [
    [/apple\s*green/, 'applegreen'], [/yellow\s*green/, 'yellowgreen'], [/light\s*green/, 'lightgreen'],
    [/light\s*blue|sky\s*blue/, 'lightblue'], [/hot\s*pink/, 'hotpink'], [/carmine/, 'red'],
    [/deep\s*orange/, 'orange'], [/orange\s*brown/, 'orangebrown'], [/squirrel\s*grey/, 'taupe'],
    [/traffic\s*purple|verkeerspaars/, 'purple']
  ];
  var NONE = /ohne\s*stempelkissen|without\s*ink\s*pad|zonder\s*stempelkussen|o\.\s*kissen|w\/o\s*pad|z\.\s*kussen|kein\s*kissen|no\s*pad|geen\s*kussen/;
  var WOOD = /holzstempel|wooden\s*stamp|houten\s*stempel/;

  function tokens(s) { return s.split(/[^a-zA-ZÀ-ɏ]+/).filter(Boolean); }
  function wordKey(t) {
    for (var k in WORDS) if (WORDS[k].indexOf(t) !== -1) return k;
    return null;
  }
  function classify(raw) {
    var s = String(raw || '').toLowerCase().trim();
    if (!s) return null;
    if (NONE.test(s)) return { key: 'none' };
    if (WOOD.test(s)) return { key: 'wood' };
    var i;
    for (i = 0; i < BRAND.length; i++) if (BRAND[i][0].test(s)) return { key: BRAND[i][1] };
    if (/pastel/.test(s)) {
      if (/pink|roze|rosa/.test(s)) return { key: 'ppink' };
      if (/lila|lilac|violet|paars/.test(s)) return { key: 'plilac' };
      if (/blau|blue/.test(s)) return { key: 'pblue' };
      if (/gr(ü|ue)n|green|groen|mint/.test(s)) return { key: 'pgreen' };
      if (/cr[eè]m|cream|orange|oranje/.test(s)) return { key: 'pcream' };
      return null;
    }
    for (i = 0; i < PHRASES.length; i++) if (PHRASES[i][0].test(s)) return { key: PHRASES[i][1] };
    var found = [], seen = {}, tk = tokens(s);
    for (i = 0; i < tk.length; i++) {
      var k = wordKey(tk[i]);
      if (k && !seen[k]) { seen[k] = 1; found.push(k); }
    }
    if (found.length === 0) return null;
    if (found.length === 1) return { key: found[0] };
    return { key: 'multi', colors: found.map(function (k) { return P[k][0]; }) };
  }

  function apply(root) {
    var inputs = (root || document).querySelectorAll('.product-form__input--pill input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i], label = inp.nextElementSibling;
      if (!label || label.tagName !== 'LABEL') continue;
      var r = classify(inp.value);
      if (!r) {
        inp.removeAttribute('data-kp');
        label.style.removeProperty('--kp-ring'); label.style.removeProperty('--kp-bg'); label.style.removeProperty('--kp-grad');
        continue;
      }
      inp.setAttribute('data-kp', r.key);
      if (r.key === 'multi') {
        label.style.setProperty('--kp-grad', 'linear-gradient(100deg,' + r.colors.join(',') + ')');
        label.style.setProperty('--kp-bg', '#ffffff');
        label.style.removeProperty('--kp-ring');
      } else {
        label.style.setProperty('--kp-ring', P[r.key][0]);
        label.style.setProperty('--kp-bg', P[r.key][1]);
        label.style.removeProperty('--kp-grad');
      }
    }
  }
  /* Stil-Regeln: Ring + Hintergrund nur bei gewählter Farbe; Mehrfarb-Werte mit Verlauf.
     Alle var() mit Rückfallwert, damit nie ein Rand "verschwindet". */
  var CSS = '.product-form__input--pill input[data-kp][data-kp]:checked+label{border:3px solid var(--kp-ring,#4a4444) !important;background:var(--kp-bg,#fff) !important;color:#121212 !important;}' +
    '.product-form__input--pill input[data-kp="multi"][data-kp]:checked+label{border:3px solid transparent !important;background:linear-gradient(#fff,#fff) padding-box,var(--kp-grad,#4a4444) border-box !important;color:#121212 !important;}';
  if (typeof document !== 'undefined' && !document.getElementById('kp-farbringe-css')) {
    var st = document.createElement('style');
    st.id = 'kp-farbringe-css';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }
  window.kpFarbringe = { classify: classify, apply: apply, palette: P, version: 5.2 };
  if (typeof document !== 'undefined' && document.addEventListener) {
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () { scheduled = false; apply(); }, 0);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { apply(); }); else apply();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
